window.PlummeI18n.register('no', {
  'pref.salesMode': 'Standardvisning for nye salg',
  'pref.salesModeSub': 'Brukes for faktura, tilbud, ordrebekreftelse, kreditnota og annet salg. Du kan bytte visning midlertidig i skjemaet.',
  'pref.purchaseMode': 'Standardvisning for nye kjøp',
  'pref.purchaseModeSub': 'Velg om nye kjøp normalt skal åpnes steg for steg eller med hele skjemaet på én side.',
  'pref.mode.firstChoiceHelp': 'Valget blir standarden din. Du kan bytte visning i skjemaet eller endre standarden senere under Innstillinger → Preferanser.',
  'pref.mode.saveFailed': 'Visningen ble byttet, men standardvalget kunne ikke lagres. Prøv igjen under Innstillinger → Preferanser.',
  'pref.mode.unsupported': 'Ugyldig visningsvalg.',
});
